/*
 * @Author: 冯超
 * @Date: 2020-02-20 15:05:27
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-11-23 20:46:17
 * @Description: 数据字典
 * @FilePath: /workplat-pc/src/common/dict.js
 */
import { utils } from '@/common/linkeaiui.shared'
const { register } = utils.lookup
import * as CONSTANTS from './constants'
import * as CONSTANTS_WP from '@/common/constants-wp'
// 注册启用 禁用
register(CONSTANTS.ACTIVE_DICT, [
  {
    code: 1,
    name: '启用'
  },
  {
    code: 2,
    name: '禁用'
  }
])
// 门户授权类型
register(CONSTANTS.AUTH_TYPE_DICT, [
  {
    code: CONSTANTS.ORG_SELECT_TYPE_ORG,
    name: '组织'
  },
  {
    code: CONSTANTS.ORG_SELECT_TYPE_USER,
    name: '用户'
  },
  {
    code: CONSTANTS.ORG_SELECT_TYPE_ROLE,
    name: '角色'
  }
])

// 门户状态
register(CONSTANTS.PORTAL_STATE, [
  {
    code: '1',
    name: '已发布'
  },
  {
    code: '0',
    name: '调整中'
  }
])

// 菜单类型
register(CONSTANTS.MENU_TYPE, [
  {
    code: 1,
    name: '目录'
  },
  {
    code: 2,
    name: '菜单'
  }
])

// 内容审核状态
register(CONSTANTS.AUDIT_STATUS, [
  { code: 1, name: '未审核' },
  { code: 2, name: '已审核' }
])
// 内容授权范围
register(CONSTANTS.AUTH_SCOPE, [
  { code: 1, name: '不限制' },
  { code: 2, name: '指定用户' }
])

// 限行范围
register(CONSTANTS.POLICY_TYPE_DICT, [
  { code: 1, name: '周次' },
  { code: 2, name: '单双号' }
])

// 请求方式
register(CONSTANTS.HTTP_METHOD, [
  {
    code: 0,
    name: 'POST'
  },
  {
    code: 1,
    name: 'GET'
  },
  {
    code: 2,
    name: 'DELETE'
  },
  {
    code: 3,
    name: 'PUT'
  }
])

// 请求方式
register(CONSTANTS.HTTP_CONTENT_TYPE, [
  {
    code: 'application/form-data',
    name: 'application/form-data'
  },
  {
    code: 'application/x-www-form-urlencoded',
    name: 'application/x-www-form-urlencoded'
  },
  {
    code: 'application/javascript',
    name: 'application/javascript'
  },
  {
    code: 'application/json',
    name: 'application/json'
  },
  {
    code: 'text/plain',
    name: 'text/plain'
  },
  {
    code: 'text/html',
    name: 'text/html'
  },
  {
    code: 'application/xml',
    name: 'application/xml'
  }
])

// 待办注册集成方式
register(CONSTANTS.INTEGRETE_TYPE, [
  {
    code: 1,
    name: '业务系统主动(内部存储)'
  },
  {
    code: 2,
    name: '业务系统被动(API方式)'
  },
  {
    code: 3,
    name: '业务系统被动(SQL Server数据库)'
  },
  {
    code: 4,
    name: '业务系统被动(Oracle数据库)'
  },
  {
    code: 5,
    name: '业务系统被动(MySql数据库)'
  },
  {
    code: 6,
    name: '业务系统被动(SQLite数据库)'
  },
  {
    code: 7,
    name: 'LKAPI'
  }
])

// 应用类型
register(CONSTANTS_WP.APPLICATION_TYPE_VALUE_DICT, [
  {
    code: '0',
    name: 'Web'
  },
  {
    code: '1',
    name: '移动端'
  }
])

// 上架状态
register(CONSTANTS_WP.ON_SHELF_STATUS_DICT, [
  {
    code: '0',
    name: '下架'
  },
  {
    code: '1',
    name: '上架'
  }
])

// 是否控权
register(CONSTANTS_WP.CONTROL_ORNOT_DICT, [
  {
    code: '0',
    name: '否'
  },
  {
    code: '1',
    name: '是'
  }
])

// 审批状态
register(CONSTANTS_WP.APPROVAL_STATUS_DICT, [
  {
    code: '0',
    name: '待提交'
  },
  {
    code: '1',
    name: '待审批'
  },
  {
    code: '2',
    name: '已通过'
  },
  {
    code: '3',
    name: '已驳回'
  },
  {
    code: '4',
    name: '新建'
  }
])

// 服务权限
register(CONSTANTS_WP.APPLICATION_APPLY_SERVICES, [
  {
    code: '0',
    name: '统一流程服务'
  },
  {
    code: '1',
    name: '统一消息服务'
  },
  {
    code: '2',
    name: '资讯接入服务'
  },
  {
    code: '3',
    name: '日志分析服务'
  },
  {
    code: '4',
    name: '分布式文件存储服务'
  },
  {
    code: '5',
    name: '日程服务'
  },
  {
    code: '6',
    name: '授权服务'
  },
  {
    code: '7',
    name: '用户服务'
  },
  {
    code: '8',
    name: '统一认证'
  }
])

// 是否启用
register(CONSTANTS_WP.DICT_ITEM_DISABLED, [
  {
    code: 1,
    name: '否'
  },
  {
    code: 0,
    name: '是'
  }
])
